export enum LegalSubjectType {
  SelfEmployedPerson = '1',
  IndividualEntrepreneur = '2',
  LimitedLiabilityCompany = '3',
  PubliclyTradedCompany = '4',
}

const {
  IndividualEntrepreneur,
  LimitedLiabilityCompany,
  SelfEmployedPerson,
  PubliclyTradedCompany
} = LegalSubjectType

const nameMapping = new Map([
  [SelfEmployedPerson, 'Самозанятый'],
  [IndividualEntrepreneur, 'Индивидуальный предприниматель'],
  [LimitedLiabilityCompany, 'Общество с ограниченной ответственностью'],
  [PubliclyTradedCompany, 'Открытое акционерное общество']
])

const shortNameMapping = new Map([
  [SelfEmployedPerson, 'Самозанятый'],
  [IndividualEntrepreneur, 'ИП'],
  [LimitedLiabilityCompany, 'ООО'],
  [PubliclyTradedCompany, 'ОАО']
])

export const LegalSubjectTypeUtils = {
  sortedMembersForBillingAccount: [SelfEmployedPerson, IndividualEntrepreneur],
  sortedMembersForSupplierApplication: [LimitedLiabilityCompany, PubliclyTradedCompany, IndividualEntrepreneur],
  getName: (x: LegalSubjectType): string => nameMapping.get(x)!,
  getShortName: (x: LegalSubjectType): string => shortNameMapping.get(x)!
}
